import { GetterTree } from 'vuex';
import { RootState } from '@/plugins/store';
import { EquipementState } from './state';
import PreventiveOutWidgetItems from '@/models/PreventiveOutWidgetItems';
import { PreventiveChartWidgetItems, PreventiveCircleWidgetItems } from '@/models/PreventiveWidgetItems';

export const getters: GetterTree<EquipementState, RootState> = {
    getPreventiveStatsCircle(state): PreventiveCircleWidgetItems {
        return state.preventiveStatsCircle;
    },
    getPreventiveStatsChart(state): PreventiveChartWidgetItems {
        return state.preventiveStatsChart;
    },
    getDevisStats: state => state.devisStats,
    getDemandesInterventionStats: state => state.demandesInterventionStats,
    isLoading: state => state.isLoading,
    isNonPreventiveStatsLoading: state => state.isNonPreventiveStatsLoading,
    isPreventiveStatsCircleLoading: state => state.isPreventiveStatsCircleLoading,
    isPreventiveStatsChartLoading: state => state.isPreventiveStatsChartLoading,
    isDevisStatsLoading: state => state.isDevisStatsLoading,
    isDemandesInterventionStatsLoading: state => state.isDemandesInterventionStatsLoading,
    hasError: state => state.error,

    getNonPreventiveStats(state): PreventiveOutWidgetItems {
        return state.nonPreventiveStats;
    },

    getTabs: state => state.tabs,

    //Historique Devis
    getHistoriqueDemandesInterventions: state => state.historiqueDemandesInterventions.demandesIntervention,
    getHistoriqueDemandesInterventionsLoading: state => state.historiqueDemandesInterventions.isLoading,
    getHistoriqueDemandesInterventionsHeaders: state => state.historiqueDemandesInterventions.tableHeader,
    getHistoriqueDemandesInterventionsCount: state => state.historiqueDemandesInterventions.count,
    getHistoriqueDemandesInterventionsNbOfPages: state => state.historiqueDemandesInterventions.nbOfPages,
    getHistoriqueDemandesInterventionsPage: state => state.historiqueDemandesInterventions.page,
    getHistoriqueDemandesInterventionsSort: state => state.historiqueDemandesInterventions.sort,
    getHistoriqueDemandesInterventionsFilter: state => state.historiqueDemandesInterventions.filter,
    getHistoriqueDemandesInterventionsExportXlsIsLoading: state =>
        state.historiqueDemandesInterventions.isExportXlsLoading,

    // Historique Travaux
    getHistoriqueTravaux: state => state.historiqueTravaux.items,
    getHistoriqueTravauxLoading: state => state.historiqueTravaux.isLoading,
    getHistoriqueTravauxHeaders: state => state.historiqueTravaux.tableHeader,
    getHistoriqueTravauxCount: state => state.historiqueTravaux.count,
    getHistoriqueTravauxNbOfPages: state => state.historiqueTravaux.nbOfPages,
    getHistoriqueTravauxPage: state => state.historiqueTravaux.page,
    getHistoriqueTravauxSort: state => state.historiqueTravaux.sort,
    getHistoriqueTravauxFilter: state => state.historiqueTravaux.filter,
    getHistoriqueTravauxExportXlsIsLoading: state => state.historiqueTravaux.exportXlsIsLoading,

    // Interventions Préventives
    getInterventionsPreventives: state => state.interventionsPreventives.items,
    getInterventionsPreventivesLoading: state => state.interventionsPreventives.isLoading,
    getInterventionsPreventivesHeaders: state => state.interventionsPreventives.tableHeader,
    getInterventionsPreventivesCount: state => state.interventionsPreventives.count,
    getInterventionsPreventivesNbOfPages: state => state.interventionsPreventives.nbOfPages,
    getInterventionsPreventivesPage: state => state.interventionsPreventives.page,
    getInterventionsPreventivesSort: state => state.interventionsPreventives.sort,
    getInterventionsPreventivesFilter: state => state.interventionsPreventives.filter,
    getInterventionsPreventivesExportXlsIsLoading: state => state.interventionsPreventives.exportXlsIsLoading,

    //Historique-Devis
    getHistoriqueDevis: state => state.historiqueDevis.devis,
    getHistoriqueDevisFilter: state => state.historiqueDevis.filter,
    getHistoriqueDevisIsLoading: state => state.historiqueDevis.isLoading,
    getHistoriqueDevisPage: state => state.historiqueDevis.page,
    getHistoriqueDevisNbOfPages: state => state.historiqueDevis.nbOfPages,
    getHistoriqueDevisScroll: state => state.historiqueDevis.scroll,
    getHistoriqueDevisSort: state => state.historiqueDevis.sort,
    getHistoriqueDevisCount: state => state.historiqueDevis.count,
    getHistoriqueDevisTableHeader: state => state.historiqueDevis.tableHeader,
    getHistoriqueDevisBonCommande: state => state.historiqueDevis.bonDeCommandeFile,
    getHistoriqueDevisIsExportXlsLoading: state => state.historiqueDevis.isExportXlsLoading,

    // Caractéristiques / Maintenances
    getCaracteristiquesHeaders: state => state.caracteristiquesHeaders,
    getMaintenancesHeaders: state => state.maintenancesHeaders,
    getCaracteristiquesData: state => state.caracteristiquesArticle,
    getCaracteristiquesLoading: state => state.isCaracteristiquesLoading,
    getMaintenancesData: state => state.operations,
    getMaintenancesLoading: state => state.isOperationMaintenanceLoading,

    //Documents règlementaires
    getDocumentReglementaireItems: state => state.documentReglementaire.documentReglementaire,
    getAdrItems: state => state.documentReglementaire.adr,
    getPriseEnChargeItems: state => state.documentReglementaire.prisesEnCharge,
    getDocumentReglementaireFilter: state => state.documentReglementaire.filter,
    getDocumentReglementairePage: state => state.documentReglementaire.page,
    getDocumentReglementaireNbOfPages: state => state.documentReglementaire.nbOfPages,
    getDocumentReglementaireScroll: state => state.documentReglementaire.scroll,
    getDocumentReglementaireSort: state => state.documentReglementaire.sort,
    getDocumentReglementaireCount: state => state.documentReglementaire.count,
    getDocumentReglementaireTableHeader: state => state.documentReglementaire.tableHeader,
    getAdrTableHeader: state => state.documentReglementaire.tableAdrHeader,
    getPecTableHeader: state => state.documentReglementaire.tablePecHeader,
    getDocumentReglementaireIsLoading: state => state.documentReglementaire.isLoading,
    getZipIsLoading: state => state.documentReglementaire.isZipLoading,
    getNombreDocumentModal: (state): number => state.documentReglementaire.nombreDocumentModal,
    getListTypesIsLoading: state => state.documentReglementaire.listTypesIsLoading,
};
